// Actions
export const SET_INPUTS = 'SET_INPUTS';
export const UPDATE_INPUT = 'UPDATE_INPUT';
